// Texts the scripts show, in the page's language. partials/site-texts.htm prints
// them as window.siteTexts, keyed by the English text; a text missing there
// (or on English pages) is shown in English.
const t = (text) => (window.siteTexts && window.siteTexts[text]) || text;

// "en", "fr", "de" or "it", from <html lang>
const pageLanguage = () => document.documentElement.lang || "en";

export { t, pageLanguage };
